import * as deepmerge from 'deepmerge';

export default class UspBar {
    DEFAULT_CONFIG = {
        interval: 4000,
        selectors: {
            usp: '[data-js-usp-bar-usp]'
        },
        classNames: {
            uspActive: 'usp-bar__usp--active'
        }
    };

    constructor(node, config = {}) {
        this.node = node;
        this.config = deepmerge(this.DEFAULT_CONFIG, config);

        this.init();
    }

    init() {
        this.declareNodes();
        this.start();
    }

    declareNodes() {
        this.uspNodes = this.node.querySelectorAll(this.config.selectors.usp);
    }

    start() {
        this.index = this.getRandomIndex();
        this.update();

        setInterval(() => this.next(), this.config.interval);
    }

    next() {
        this.index = this.index + 1 < this.uspNodes.length ? this.index + 1 : 0;
        this.update();
    }

    update() {
        this.uspNodes.forEach((uspNode, index) =>
            uspNode.classList.toggle(this.config.classNames.uspActive, index === this.index)
        );
    }

    getRandomIndex() {
        return Math.floor(Math.random() * this.uspNodes.length);
    }
}
